import React, { SVGProps } from "react";

export const QuantityWidgetIcon1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={101}
    height={69}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.5}
      y={6.284}
      width={99.801}
      height={61.794}
      rx={9.5}
      fill="#fff"
      stroke={props.stroke || "#BBB"}
    />
    <rect
      x={17.5}
      y={0.5}
      width={67}
      height={18}
      rx={8.5}
      fill={props.color || "#F1F1F1"}
      stroke={props.stroke || "#BBB"}
    />
  </svg>
);
